<script>


import { useToast } from "vue-toastification";

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap

import DocumentEdit from '@/components/Core/Documents/DocumentEdit.vue'
import DocumentDelete from '@/components/Core/Documents/DocumentDelete.vue'
import CheckboxToggle from '@/components/General/CheckboxToggle'
import Alert from '@/components/General/Alert'

import LoadingScreen from '@/components/General/LoadingScreen'
import UserCircle from '@/ui/UserCircle'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

//data
import { getDocumentsByLibrary, changeStateDocument } from '@/services/serviceDocument';
import { getLibraryInfo } from '@/services/serviceLibrary';

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'LibraryPreview',
	mixins: [ MixinGeneralFunct ],
	components: {
		DocumentEdit
		,DocumentDelete
		,LoadingScreen
		,CheckboxToggle
		,Alert
		,UserCircle
	},
	props: {'libraryId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},

	data() {
		return {
			prefix:'',
			
			params:[],
			metaData: [],
		
			isLoading:true,
						
			optionsGalleries:[],
			selectedLibrary:'',

			selectedDocumentId:'',

			//form
			library:[],
			documents:[],

			modalDelete:{},
			modalDeleteId:'',

			modalEdit:{},
			modalEditId:'',

		}
	},
	
	mounted:function(){
		
		this.modalDeleteId = `modal${this.getRandomInt(999999999)}`;
		this.modalEditId = `modal${this.getRandomInt(999999999)}`;

		this.onLoadPage();
		//console.log(this.libraryId)
		
		//console.log(this.$route.path)
	},
	
	methods: {
		// load data form
		onLoadPage:function(){
			
			this.isLoading=true


			getDocumentsByLibrary({libraryId:this.libraryId}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					this.documents = response.documents;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getLibraryInfo({libraryId:this.libraryId}).then(response => {
				if(!response.statusText){
					this.library = response.data;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		
		},

		
		onCloseModal:function(){
			this.modalObject.hide();
		},
		
		

		//modal box gallery editacia
		loadModalFormDocumentEdit:function(recordID){
			this.cSession();
		//	console.log(recordID)
			this.selectedDocumentId=recordID;
			this.modalEdit = new bootstrap.Modal(document.getElementById(this.modalEditId), {backdrop:'static'})
			this.modalEdit.show();
		},

		//modal box gallery delete
		loadModalFormDocumentDelete:function(recordID){
			this.cSession();
		//	console.log(recordID)
			this.selectedDocumentId=recordID;
			this.modalDelete = new bootstrap.Modal(document.getElementById(this.modalDeleteId), {backdrop:'static'})
			this.modalDelete.show();
		},

		reloadAfterChange() {
		//	console.log(e);
			this.onLoadPage();
			this.selectedDocumentId='';
		},

		//zmena stavu
		onChangeState:function(e){
			this.cSession();			
			this.isLoading=true
			changeStateDocument({recordId:e.id,state:e.state}).then(response => {
				console.log(response)
				if(!response.statusText){
					this.isLoading=false
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasSaved'));
						this.onLoadPage();
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==2){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
				}else{
					this.isLoading=false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

		},

		
		
	},
	
	watch: {
		libraryId() {
			this.onLoadPage();
		},
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>
		<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog modal-lg">
				<LoadingScreen :isLoading="isLoading"></LoadingScreen>
			<div class="modal-content">
				<div class="modal-header">
					<h6 class="modal-title">{{ $t('msgCore.Preview') }} <span><b>{{ library.title }}</b> </span></h6>
				</div>
		
				<div class="modal-body">
					<div v-if="documents.length>0" class="row">
						<div class="col-12">
							<div class="table-responsive">
								<table class="table table-hover table-sm">
											
									<thead>
										<tr>
											<th>ID</th>
											
											<th>{{$t('msgCore.Action')}}</th>

											<th colspan="2">{{$t('msgCore.State')}}</th>
											
											<th>{{$t('msgCore.Title')}}</th>
											
											<th>{{$t('msgCore.Extension')}}</th>
											
											<th>{{$t('msgCore.Size')}}</th>
											
											<th>{{$t('msgCore.Created')}}</th>
											
											<th>{{$t('msgCore.Modified')}}</th>

											<th>{{$t('msgCore.AccessLevel')}}</th>									
										</tr>
									</thead>
							
								
									<tr v-for="document in documents" :key="document" >
										<td>{{document.id}}</td>
										
										<td>
											<div class="btn-group">				
												<button type="button" :disabled="!auth.documentsEdit" v-on:click="loadModalFormDocumentEdit(document.id)" :title="$t('msgCore.btnEdit')" id="myModalBtn" class="btn btn-secondary btn-sm"><i class="smire-icon fas fa-edit"></i></button>
												
												<button type="button" :disabled="!auth.documentsDelete" v-on:click="loadModalFormDocumentDelete(document.id)" :title="$t('msgCore.btnDelete')" id="myModalBtn" class="btn btn-danger btn-sm"><i class="smire-icon fas fa-trash-alt"></i></button>
																										
											</div>
										</td>

										<td  :title="$t('msgCore.' + document.state_name)">
											<i class="fas fa-circle" :class="{'text-success':document.state==1,'text-danger':document.state==2}" ></i>
										</td>	

										<td>
											<CheckboxToggle :key="document.id" :isDisabled="(!auth.documentsChangeState)" :data="document" @onClick="onChangeState"></CheckboxToggle>
										</td>
											
										<td><a :href="document.url">{{document.title}}</a></td>
										
										<td>{{document.extension}}</td>
										
										<td>{{document.fileSize}}</td>
										
										
										<td>
											<UserCircle :firstName="document.creatorFirstName" :surName="document.creatorSurName" :color="document.creatorColor" :date="document.created"/>
                                        </td>

										<td>
											<UserCircle :firstName="document.editorFirstName" :surName="document.editorSurName" :color="document.editorColor" :date="document.modified"/>
                                        </td>
										
										<td>{{document.access_name}}</td>	
									
									</tr>
								
								</table>
							</div>
						</div>
					</div>
					
					<div v-else class="row">
						<div class="col-12 mt-3">
							<Alert type="warning" :label="$t('msgCore.forThisSelectExistAnyData')" />	
						</div>							
					</div>
					
				</div>
				
				<div class="modal-footer">
					<div class="btn-group">
						<button type="button" v-on:click="onCloseModal()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>

						
					</div>	
				</div>
					
			</div>

		</div>
		
	</div>
	
	<DocumentEdit :auth="auth" :secData="secData" :documentId="String(selectedDocumentId)" @changeRecord="reloadAfterChange" :modalObject="modalEdit" :modalId="modalEditId"></DocumentEdit>
	<DocumentDelete :auth="auth" :secData="secData" :documentId="String(selectedDocumentId)" @changeRecord="reloadAfterChange" :modalObject="modalDelete" :modalId="modalDeleteId"></DocumentDelete>
</div>
</template>


